<template>
  <!-- Teleport target container -->
  <!-- Always render when id exists, but hide when not needed -->
  <!-- This ensures the target element exists in DOM before Teleport tries to use it -->
  <div
    v-if="id"
    :id="id"
    :style="{ display: visible ? 'block' : 'none' }"
  />
</template>

<script>
export default {
  name: 'TeleportTarget',
  props: {
    // ID of the teleport target element
    id: {
      type: String,
      default: '',
    },
    // Whether the target should be visible
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

